export const isDevelopment = process.env.NODE_ENV === "development";

export const isMobile = () => {
  return typeof window !== "undefined" && window.innerWidth < 600;
};

/** True when UA is a known crawler. Set by inline script in index.html; nginx replaces "= false;" with "= true;" for bots. */
export const isCrawler = (): boolean =>
  typeof window !== "undefined" && !!(window as any).__IS_CRAWLER__;

export const isTouchDevice = () => {
  if (typeof window === "undefined") return false;

  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    (navigator as any).msMaxTouchPoints > 0
  );
};

const imgurl = isDevelopment
  ? "/api/slow-images/"
  : "https://images.hexagen.world/";
// In dev, load videos directly from CDN (avoids proxy/backend parsing issues with @ in path)
const videoUrl = "https://images.hexagen.world/";
export const img = (name: string) => imgurl + name;

const appendVersion = (url: string, version?: number | null): string =>
  version != null && version > 0 ? `${url}?v=${version}` : url;

export const imgFromCoords = (x: number, y: number, version?: number | null) =>
  appendVersion(imgurl + `x${x}y${y}.png`, version);

/** Tile URL for map/card: highQuality = 1024px (@big), else 512px. */
export const imgTileFromCoords = (
  x: number,
  y: number,
  highQuality: boolean,
  version?: number | null
) => appendVersion(imgurl + `x${x}y${y}${highQuality ? "@big" : ""}.png`, version);

export const videoFromCoords = (x: number, y: number, version?: number | null) =>
  appendVersion(videoUrl + `x${x}y${y}@video.mp4`, version);

export const rootURL = isDevelopment
  ? "http://localhost:3000"
  : "https://hexagen.world";
